/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2018/12/5
 */
import {createContext, useContext} from 'react'

export const projectLayoutWrapContext = createContext({})

export function useProjectLayoutWrapContext() {
    return useContext(projectLayoutWrapContext)
}
